import {
  getFriendlyErrorMessage,
  NETWORK_ERROR_MESSAGE,
} from "../../utils/apiErrors";
import { StaffContactFormData } from "./types";

const API_BASE_URL = process.env.REACT_APP_BE_API_URL;

export const submitStaffContactForm = async (
  contactData: StaffContactFormData,
  recaptchaToken: string | null,
): Promise<any> => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/staffContactFormMessages/submit`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...contactData,
          recaptchaToken,
        }),
      },
    );

    if (!response.ok) {
      let friendlyMessage = "";

      try {
        const errorData = await response.json();
        friendlyMessage = errorData.message || errorData.error;
      } catch (e) {
        // No hay JSON o mensaje en la respuesta
      }

      if (!friendlyMessage) {
        friendlyMessage = getFriendlyErrorMessage(response.status, "contact");
      }

      const error = new Error(friendlyMessage);
      (error as any).friendlyMessage = friendlyMessage;
      (error as any).status = response.status;
      throw error;
    }

    return await response.json();
  } catch (error: any) {
    if (error.friendlyMessage) throw error;

    const networkError = new Error("Error de conexión");
    (networkError as any).friendlyMessage = NETWORK_ERROR_MESSAGE;
    throw networkError;
  }
};
